import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=437b9848"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=437b9848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports